import { selector } from 'recoil';
import ordersAtom from '../atom/orders';
import cartTypeAtom from '../atom/cartType';

import * as fp from 'lodash/fp';

import calcItemTotal from '~/utils/calcItemTotal';

import { CartType, StoreOrderInCart } from '~/types/cart';
import enterpriseGroupBuyOrdersAtom from '../atom/enterpriseGroupBuy/enterpriseGroupBuyOrders';
import globalEnterpriseGroupBuyAtom from '../atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';

const itemsTotalPerStoreMap = selector<Map<string, number>>({
  key: 'itemsTotalPerStoreMap',
  get: ({ get }) => {
    const cartType = get(cartTypeAtom);
    const { data = null } = get(globalEnterpriseGroupBuyAtom);
    const orders = get(!!data ? enterpriseGroupBuyOrdersAtom : ordersAtom);

    const calcItemsFn: (order: StoreOrderInCart) => number =
      cartType === CartType.CART_PERSONAL
        ? fp.pipe(fp.prop('items'), fp.sumBy(calcItemTotal))
        : fp.pipe(
            fp.prop('groupItems'),
            fp.flatMap(fp.propOr([], 'items')),
            fp.sumBy(calcItemTotal),
          );

    return new Map(orders.map((order) => [order.storeId, calcItemsFn(order)]));
  },
});

export default itemsTotalPerStoreMap;
